import {Component, Input, OnInit} from '@angular/core';
import {AppSettingsService} from '../../services/app-settings.service';
import {Question} from '../../model/GeneralModels';
import {FormGroup} from '@angular/forms';

@Component({
  selector: 'app-form-list-generator',
  template: `
    <div>
      <div [formGroup]="Group" *ngFor="let question of questionList; let index = index">
        <div *ngIf="question.getDataType()[0]"
             [ngSwitch]="question.getDataType()[0]">
          <app-input-field *ngSwitchCase="'text'"
                           [Group]="Group"
                           [viewList]="viewList" [translation]="translation"
                           [dataType]="question.getDataType()"
                           [fieldLabel]="question.getPersianLabel()"
                           [fieldName]="question.getEnglishLabel()"
                           [even]="0 === index % 2 && twoCol"
                           [testAutoFill]="!hasFather"
                           [value]="question.getAnswer()"
                           [twoCol]="twoCol">
          </app-input-field>
          <app-input-field *ngSwitchCase="'number'"
                           [Group]="Group"
                           [viewList]="viewList" [translation]="translation"
                           [dataType]="question.getDataType()"
                           [fieldLabel]="question.getPersianLabel()"
                           [fieldName]="question.getEnglishLabel()"
                           [even]="0 === index % 2 && twoCol"
                           [testAutoFill]="!hasFather"
                           [value]="question.getAnswer()"
                           [twoCol]="twoCol">
          </app-input-field>
          <app-state-and-city-field *ngSwitchCase="'StateAndCityList'"
                                    [stateFieldName]="'stateID'"
                                    [cityFieldName]="'cityID'"
                                    [productName]="productName"
                                    [viewList]="viewList"
                                    [required]="question.isRequired()"
                                    [form]="Group"
          ></app-state-and-city-field>
          <app-company-field *ngSwitchCase="'CompanyList'"
                             [viewList]="viewList"
                             [required]="question.isRequired()"
                             [Group]="Group"
                             [productName]="productName"
          ></app-company-field>
          <app-company-franchise-field *ngSwitchCase="'CompanyFranchiseList'"
                                       [viewList]="viewList"
                                       [productName]="productName"
                                       [required]="question.isRequired()"
                                       [Group]="Group"
          ></app-company-franchise-field>
          <app-device-type-brand-model-list *ngSwitchCase="'DeviceTypeBrandModelList'"
                                            [viewList]="viewList"
                                            [productName]="productName"
                                            [required]="question.isRequired()"
                                            [Group]="Group"
          ></app-device-type-brand-model-list>
          <app-input-field *ngSwitchCase="'textarea'"
                           [Group]="Group"
                           [viewList]="viewList"
                           [translation]="translation"
                           [dataType]="question.getDataType()"
                           [fieldLabel]="question.getPersianLabel()"
                           [fieldName]="question.getEnglishLabel()"
                           [even]="0 === index % 2 && twoCol"
                           [twoCol]="twoCol"
                           [value]="question.getAnswer()"
                           [testAutoFill]="!hasFather">
          </app-input-field>
          <app-select-field *ngSwitchCase="'select'"
                            [Group]="Group" [translation]="translation"
                            [viewList]="viewList" [value]="question.getAnswer()"
                            [options]="question.getDataType()[1]"
                            [fieldName]="question.getEnglishLabel()"
                            [fieldLabel]="question.getPersianLabel()"
                            [even]="0 === index % 2 && twoCol"
          >
          </app-select-field>
          <app-date-picker-field *ngSwitchCase="'DATE'" [fieldName]="question.getEnglishLabel()"
                                 [fieldLabel]="question.getPersianLabel()" [Group]="Group"
                                 [viewList]="viewList" [dateValue]="question.getAnswer()"
                                 [minAge]="question.getDataType()[1] && question.getDataType()[1][0] !== null ? question.getDataType()[1][0] : null"
                                 [maxAge]="question.getDataType()[1] && question.getDataType()[1][1] !== null ? question.getDataType()[1][1] : null"
                                 [even]="0 === index % 2 && twoCol" [Icon]="false">
          </app-date-picker-field>
          <app-checkbox-field *ngSwitchCase="'checkbox'"
                              [fieldName]="question.getEnglishLabel()"
                              [fieldLabel]="question.getPersianLabel()"
                              [even]="0 === index % 2 && twoCol"
                              [Group]="Group" [viewList]="viewList"
                              [productName]="productName" [value]="question.getAnswer()"
                              [subList]="question.getSubQuestionList() || null"
                              [ngClass]="{'col col-4': 0 === index % 2 && twoCol}"
                              [hasFather]="hasFather"
          ></app-checkbox-field>
          <app-limited-integer-list-select *ngSwitchCase="'intList'"
                                           [Group]="Group" [viewList]="viewList"
                                           [ngClass]="{'col col-4': 0 === index % 2 && twoCol}"
                                           [translation]="translation"
                                           [required]="question.isRequired()"
                                           [questionEnglishName]="question.getEnglishLabel()"
                                           [max]="question.getDataType()[1]"
          ></app-limited-integer-list-select>
        </div>
      </div>
    </div>
  `,
  styles: [`
    .example-form-row {
      /*min-width: 150px;*/
      /*max-width: 500px;*/
      /*width: 100%;*/
      align-content: center;
    }

    .example-full-width {
      width: 100%;
    }

    .mat-card {
      height: 40px;
    }

    .mat-checkbox-layout .mat-checkbox-label {
      line-height: 10px;
    }

  `]
})
export class FormListGeneratorComponent implements OnInit {
  @Input() questionList: Question[];
  @Input() noCheckBox: boolean;
  @Input() productName: string;
  @Input() Group: FormGroup;
  @Input() SingleThreads: boolean;
  @Input() viewList: any = {};
  @Input() translation: any = {};
  @Input() twoCol: boolean;
  @Input() hasFather: boolean;

  constructor() {
  }

  ngOnInit() {
  }

  getIntValue(input: string): number {
    return input !== '' ? parseInt(input, 10) : 0;
  }

}
